export class AppRoutingConfig {
  // Main
  public static readonly structuresUrl = 'Structures'

  // Master Key System Profile
  public static readonly newStructureUrl = AppRoutingConfig.structuresUrl + '/new'
  public static readonly structureNew = {
    url: `${AppRoutingConfig.structuresUrl}/:structureId`,
  }
  public static readonly structureNewKeySystems = {
    url: `${AppRoutingConfig.structuresUrl}/:structureId/Systems`,
    path: 'Systems',
  }
  public static readonly structureHistory = {
    url: `${AppRoutingConfig.structuresUrl}/:structureId/AuditTrail`,
    path: 'AuditTrail',
  }
  public static readonly structure = {
    url: `${AppRoutingConfig.structuresUrl}/:structureId/Systems/:keySystemId`,
  }
  public static readonly structureBudget = {
    url: AppRoutingConfig.structuresUrl + '/:structureId/Systems/:keySystemId/Budget',
    path: 'Budget',
  }
  public static readonly structureHierarchy = {
    url: AppRoutingConfig.structuresUrl + '/:structureId/Systems/:keySystemId/Hierarchy',
    path: 'Hierarchy',
  }
  public static readonly keySystemReports = {
    url: AppRoutingConfig.structuresUrl + '/:structureId/Systems/:keySystemId/Reports',
    path: 'Reports',
  }
  // public static readonly keySystemHistory = {
  //   url: AppRoutingConfig.structuresUrl + '/:structureId/Systems/:keySystemId/AuditTrail',
  //   path: 'AuditTrail',
  // }  
  public static readonly structureOrderDetails = {
    url: AppRoutingConfig.structuresUrl + '/:structureId/Systems/:keySystemId/Orders',
    path: 'AuditTrail',
  }

  public static readonly keySystemRegistryNumbers = {
    url: AppRoutingConfig.structuresUrl + '/:structureId/Systems/:keySystemId/RegistryNumbers',
    path: 'RegistryNumbers',
  }

  public static readonly keySystemTools = {
    url: AppRoutingConfig.structuresUrl + '/:structureId/Systems/:keySystemId/Tools',
    path: 'Tools',
  }

  public static readonly structureSettings = {
    url: AppRoutingConfig.structuresUrl + '/:structureId/Systems/:keySystemId/Settings',
    path: 'Settings',
  }
  public static readonly dealerMasterKey = {
    url: AppRoutingConfig.structuresUrl + '/:structureId/Systems/:keySystemId/Dealer',
    path: 'Dealer',
  } 

  // Other
  public static readonly callbackUrl = 'callback'
  public static readonly logoutUrl = 'logout'
  public static readonly otherUrl = '**'
  public static readonly emptyUrl = ''
  public static readonly supportUrl = 'support'

  public static getStructureUrlNew(structureId: number): string {
    return this.structureNewKeySystems.url.replace(':structureId', String(structureId))
  }

  public static getStructureUrl(structureId: number, keySystemId: number): string {
    return this.structure.url.replace(':structureId', String(structureId)).replace(':keySystemId', String(keySystemId))
  }

  public static getStructureHierarchyUrl(structureId: number, keySystemId: number): string {
    return this.structureHierarchy.url
      .replace(':structureId', String(structureId))
      .replace(':keySystemId', String(keySystemId))
  }

  public static getStructureBudgetUrl(structureId: number, keySystemId: number): string {
    return this.structureBudget.url
      .replace(':structureId', String(structureId))
      .replace(':keySystemId', String(keySystemId))
  }

  public static getGenericUrl(name, structure, keySystemId: number): string {
    return this[name].url.replace(':structureId', String(structure)).replace(':keySystemId', String(keySystemId))
  }

  public static getGenericStructureUrl(name, structure): string {
    return this[name].url.replace(':structureId', String(structure))
  }

  public static getDealerKeySystemUrl(structureId: number, keySystemId: number): string {
    return this.dealerMasterKey.url
      .replace(':structureId', String(structureId))
      .replace(':keySystemId', String(keySystemId))
  }

  public static getAuditTrailUrl(name, structure, keySystemId: number): string {
    return this[name].url.replace('Orders','AuditTrail').replace(':structureId', String(structure)).replace(':keySystemId', String(keySystemId))
  }
}
